module.exports = __webpack_public_path__ + "img/your_cosplay.7179587b.jpg";